import { writable } from 'svelte/store'

export const quantity = writable(1)
export const postal = writable(false)
export const shipping = writable(false)
export const method = writable('Pickup')